import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import type { MaintenanceStatusResponse } from './maintenanceTypes';

export const getMaintenanceStatusQuery = () =>
  queryOptions({
    queryKey: queryKeys.adminMaintenance.status(),
    queryFn: async () => {
      const response = await api
        .get('admin/maintenance')
        .json<MaintenanceStatusResponse>();
      return response;
    },
  });
